export default __webpack_public_path__ + "static/media/accesoDenegado.0a2aa66b.jpg";